(function () {
  function formatMoney(cents) {
    var n = Number(cents);
    if (isNaN(n)) return '';
    return '$' + (n / 100).toFixed(2);
  }

  function initGallery(root) {
    var main = root.querySelector('#sprk-product-main-img');
    if (!main) return;

    root.querySelectorAll('[data-sprk-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-src');
        var srcset = btn.getAttribute('data-srcset');
        if (src) main.setAttribute('src', src);
        if (srcset) main.setAttribute('srcset', srcset);
        root.querySelectorAll('[data-sprk-thumb]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
      });
    });
  }

  function initVariants(root) {
    var jsonEl = root.querySelector('[data-sprk-variants]');
    if (!jsonEl) return;

    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var selects = root.querySelectorAll('[data-sprk-option]');
    var variantInput = root.querySelector('[data-sprk-variant-input]');
    var priceEl = root.querySelector('[data-sprk-price]');
    var compareEl = root.querySelector('[data-sprk-compare]');
    var atcBtn = root.querySelector('[data-sprk-atc]');

    if (!variantInput || selects.length === 0) return;

    function findVariant() {
      return variants.find(function (v) {
        for (var i = 0; i < selects.length; i++) {
          var key = 'option' + (i + 1);
          if (v[key] !== selects[i].value) return false;
        }
        return true;
      });
    }

    function applyVariant(v) {
      if (!v) return;
      variantInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = formatMoney(v.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }
      if (atcBtn) {
        if (v.available) {
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add to cart — ' + formatMoney(v.price);
        } else {
          atcBtn.disabled = true;
          atcBtn.textContent = 'Sold out';
        }
      }
    }

    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var v = findVariant();
        if (v) applyVariant(v);
      });
    });
  }

  function initQty(root) {
    var input = root.querySelector('[data-sprk-qty]');
    if (!input) return;

    var dec = root.querySelector('[data-sprk-qty-dec]');
    var inc = root.querySelector('[data-sprk-qty-inc]');

    function clamp() {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      input.value = String(v);
    }

    if (dec) {
      dec.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = String(Math.max(1, v - 1));
      });
    }
    if (inc) {
      inc.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = String(v + 1);
      });
    }
    input.addEventListener('change', clamp);
  }

  function initFaq(root) {
    var items = root.querySelectorAll('.sprk-product-faq details');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.sprk-product-page').forEach(function (root) {
      initGallery(root);
      initVariants(root);
      initQty(root);
      initFaq(root);
    });
  });
})();